export default "__VITE_ASSET__BX9uPEKr__"